(() => {
  'use strict';
  const selector = '[data-ae-direct-checkout]';

  function getForm(button) {
    return document.getElementById(button.dataset.formId || '') || button.closest('form');
  }

  function sync(button) {
    if (button.dataset.aeLoading === '1') return;
    const form = getForm(button);
    const variant = form?.querySelector('[name="id"]');
    const add = form?.querySelector('[name="add"]');
    button.disabled = !variant || !variant.value || variant.disabled || Boolean(add?.disabled);
  }

  function initialize() {
    document.querySelectorAll(selector).forEach(button => {
      sync(button);
      if (button.dataset.aeCartBound === '1') return;
      button.dataset.aeCartBound = '1';
      const add = getForm(button)?.querySelector('[name="add"]');
      if (add) new MutationObserver(() => sync(button)).observe(add, {
        attributes: true, attributeFilter: ['disabled']
      });
    });
  }

  document.addEventListener('click', async event => {
    const button = event.target.closest(selector);
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    sync(button);
    if (button.disabled || button.dataset.aeLoading === '1') return;
    const form = getForm(button);
    if (!form) return;
    const label = button.querySelector('.ae-direct-checkout__label');
    const loading = button.querySelector('.ae-direct-checkout__loading');
    button.dataset.aeLoading = '1';
    button.disabled = true;
    if (label) label.hidden = true;
    if (loading) loading.hidden = false;
    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add', {
        method: 'POST', headers: {Accept: 'application/json'},
        body: new FormData(form), credentials: 'same-origin'
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to add this item.');
      window.location.assign(button.dataset.aeCartUrl || window.routes?.cart_url || '/cart');
    } catch (error) {
      let wrapper = form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'product-form__error-message-wrapper';
        wrapper.setAttribute('role', 'alert');
        const text = document.createElement('span');
        text.className = 'product-form__error-message';
        wrapper.appendChild(text);
        form.appendChild(wrapper);
      }
      const text = wrapper.querySelector('.product-form__error-message');
      if (text) text.textContent = error.message;
      wrapper.hidden = false;
      button.dataset.aeLoading = '0';
      if (label) label.hidden = false;
      if (loading) loading.hidden = true;
      sync(button);
    }
  }, true);

  initialize();
  new MutationObserver(mutations => {
    if (mutations.some(mutation => Array.from(mutation.addedNodes).some(node =>
      node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))
    ))) initialize();
  }).observe(document.body, {childList: true, subtree: true});
  document.addEventListener('shopify:section:load', initialize);
})();
